// removed by extract-text-webpack-plugin
module.exports = {"normal":"normal__2dK6z","content":"content__3uKWy"};


//////////////////
// WEBPACK FOOTER
// ./components/Scrollable/index.scss
// module id = n7vL
// module chunks = 0